import { parse, subMonths } from "date-fns";

import { BillingCycle, ISubscription, Plan } from "store/entities/subscriptions";

const helpDeskPlanCodeRegexp = /^hd-([^\d]+)([\d]+)/;

function deserializePlanCode(planCode: string): {
  plan: Plan;
  billingCycle: BillingCycle;
} | null {
  // for Text App plans, we use Business plan as placeholder
  if (planCode.startsWith("text")) {
    return {
      plan: Plan.Business,
      billingCycle: BillingCycle.Monthly,
    };
  }

  const matches = planCode.match(helpDeskPlanCodeRegexp);
  if (!matches) {
    return null;
  }

  const [, plan, billingCycle] = matches;
  return {
    plan: plan as Plan,
    billingCycle: parseInt(billingCycle, 10) as BillingCycle,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeSubscription(data: { [key: string]: any }): ISubscription {
  const deserializedPlan = deserializePlanCode(data.planCode);
  if (!deserializedPlan) {
    // @ts-expect-error TS(2322)
    return null;
  }

  const subscriptionExpiresAt = data.expiresAt ? parse(data.expiresAt) : parse(data.currentPeriodEndsAt);

  const { plan, billingCycle } = deserializedPlan;
  return {
    id: data.subscriptionID,
    plan,
    billingCycle,
    agents: data.quantity,
    status: data.state,
    trialExpiresAt: data.trialEndsAt ? parse(data.trialEndsAt) : null,
    trialStartsAt: data.trialStartedAt ? parse(data.trialStartedAt) : null,
    pricePerAgent: data.unitAmountInCents,
    // @ts-expect-error TS(2322)
    currentPeriodEndsAt: data.currentPeriodEndsAt ? parse(data.currentPeriodEndsAt) : null,
    currentPeriodStartsAt: data.currentPeriodStartedAt
      ? parse(data.currentPeriodStartedAt)
      : subMonths(subscriptionExpiresAt, billingCycle),
    subscriptionExpiresAt,
    isCanceled: data.expiresAt !== null,
  };
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function deserializeSubscriptions(data: any[]): ISubscription[] {
  return data.map(deserializeSubscription).filter(Boolean);
}
